export { default } from "./ArticleList"
